import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { participantActions } from '../../../redux/actions';
import Text from '../../../shared/common/Text';
import {
    AddUserForm,
    AddUserImage,
    AddUserTextField,
    AutocompleteStyled,
    FormAddUserButton,
} from '../styled-components/addUser/formAddUsers.styled.components';
import { TextWrapper } from '../styled-components/users.styled.components';
import { getAllCountries } from '../../../redux/api/utils';
import { TextField } from '@material-ui/core';
import Loading from '../../../shared/common/Loading';

const FormAddUser = () => {
    // REDUX
    const dispatch = useDispatch();
    const ondemand_id = useSelector(state => state.user.user.id);
    const loadingNewParticipant = useSelector(state => state.participant.loadingNewParticipant);

    // STATES
    const [newParticipant, setNewParticipant] = useState({
        nombre: '',
        email: '',
        password: '',
        country_id: '',
        source_id: 1075,
        medium_id: 4694,
    });

    const [countries, setCountries] = useState(null);
    const [valueCountry, setValueCountry] = useState(null);
    const [inputValueCountry, setInputValueCountry] = useState('');

    //EFFETCS
    useEffect(() => {
        if (countries === null) {
            getAllCountries().then(response => {
                setCountries(Array.isArray(response.data) ? response.data : []);
            });
        }
    }, []);

    useEffect(() => {
        if (valueCountry !== null) {
            setNewParticipant({
                ...newParticipant,
                country_id: valueCountry.id,
            });
        }
    }, [valueCountry, inputValueCountry]);

    // FUNCTIONS
    function handleChange(e) {
        setNewParticipant({
            ...newParticipant,
            [e.target.name]: e.target.value,
        });
    }

    // Validación para habilitar/deshabilitar el botón de creación de usuario
    const isFormValid = () => {
        const { nombre, email, password, country_id } = newParticipant;
        return nombre.trim() !== '' && email.trim() !== '' && password.trim() !== '' && country_id !== '' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    function handleSubmit(e) {
        e.preventDefault();
        dispatch(
            participantActions.createParticipantRequest({
                newParticipant,
                ondemand_id,
            }),
        );
    }
    // RETURN
    if (countries === null) return <Loading />;
    return (
        <>
            <AddUserImage src="/images/male-avatar.svg" alt="avatar" />
            <TextWrapper>
                <Text fontSize="1.5rem" fontWeight="700">
                    Nuevo usuario
                </Text>
                <Text fontSize="1rem" fontWeight="700">
                    Crea un nuevo usuario
                </Text>
            </TextWrapper>
            <AddUserForm onSubmit={handleSubmit}>
                <AddUserTextField
                    name="nombre"
                    value={newParticipant.nombre}
                    onChange={handleChange}
                    type="text"
                    required
                    variant="outlined"
                    size="small"
                    color="primary"
                    label="Nombre completo"
                />
                <AddUserTextField
                    name="email"
                    value={newParticipant.email}
                    onChange={handleChange}
                    type="email"
                    required
                    variant="outlined"
                    size="small"
                    color="primary"
                    label="Correo electrónico"
                />
                <AddUserTextField
                    name="password"
                    value={newParticipant.password}
                    onChange={handleChange}
                    type="text"
                    required
                    variant="outlined"
                    size="small"
                    color="primary"
                    label="Contraseña"
                />

                <AutocompleteStyled
                    value={valueCountry}
                    onChange={(event, newValue) => {
                        setValueCountry(newValue);
                    }}
                    // onChange={handleChange}
                    inputValue={inputValueCountry}
                    onInputChange={(event, newInputValue) => {
                        setInputValueCountry(newInputValue);
                    }}
                    id="country_id"
                    options={countries}
                    getOptionLabel={option => option.name}
                    renderInput={params => (
                        <TextField
                            {...params}
                            label=""
                            placeholder={'País del nuevo usuario'}
                            variant="outlined"
                            required
                            style={{ width: '100%' }}
                        />
                    )}
                />
                <FormAddUserButton variant="contained" color="primary" size="small" type="submit" disabled={!isFormValid() || loadingNewParticipant}>
                    {loadingNewParticipant ? 'Creando...' : 'Crear'}
                </FormAddUserButton>
            </AddUserForm>
        </>
    );
};

export default FormAddUser;
